var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconInterfaceProcessingSmall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "outline_art_-_SVG_EXPORT",
    "data-name": "outline art - SVG EXPORT",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.61,30.92c-5.23-2.18-8.61-7.26-8.61-12.92,0-7.72,6.28-14,14-14s14,6.28,14,14h-2c0-6.62-5.38-12-12-12s-12,5.38-12,12c0,4.86,2.9,9.21,7.38,11.08l-.77,1.85Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconInterfaceProcessingSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-interface-processing-small.e3d129ab73e352b8fdd58fffaa149ed1.svg";